import React from 'react';

import { LicenseType } from '@/core/api/collections/users';
import { ReactComponent as LicenseAdminIcon } from '@/icons/license_admin.svg';
import { ReactComponent as LicenseContributorIcon } from '@/icons/license_contributor.svg';
import { ReactComponent as LicenseSupportIcon } from '@/icons/license_support.svg';

type Props = {
  invited?: boolean;
  licenseType?: LicenseType;
  uvkAdmin?: boolean;
}
export function LicenseTypeLabel ({ invited, licenseType, uvkAdmin }: Props) {
  if (invited) {
    return (
      <span className="px-2 py-1 text-xs tracking-wider text-gray-100 uppercase bg-gray-800 rounded">
        Invited
      </span>
    );
  }
  if (!licenseType && !uvkAdmin) {
    return null;
  }

  let Icon;
  let label;
  switch (licenseType) {
    case 'contributor':
      Icon = <LicenseContributorIcon width={13} height={19} />;
      label = 'Contributor';
      break;
    case 'helpdesk_admin':
      Icon = <LicenseSupportIcon width={15} height={15} />;
      label = 'Support';
      break;
    default:
      Icon = <LicenseAdminIcon width={19} height={10} />;
      label = 'Admin';
  }

  return (
    <div className="flex items-center mr-4">
      <span className="w-8">
        { Icon }
      </span>
      <span>
        { label }
      </span>
    </div>
  );
}
